import fetch from '@/plugin/axios'

// 详情
export function getList () {
  return fetch({
    url: '/api/member/hp-config/info',
    method: 'Post'
  })
}

// 更新
export function getSet (query) {
  return fetch({
    url: '/api/member/hp-config/set',
    method: 'Post',
    data: query
  })
}
